import { Component, OnInit, ViewChild } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { TestataService } from './../../../services/testata.service';
import { AppComponent } from './../../../app.component';

import { Testata } from '../../../models/Testata';

@Component({
  selector: 'app-testata-form',
  templateUrl: './testata-form.component.html',
  styleUrls: ['./testata-form.component.css'],
  providers: [TestataService]
})
export class TestataFormComponent implements OnInit {
  wmodel: Testata = new Testata();
  dirty: boolean;
  loading: boolean;
  @ViewChild('f') form: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private service: TestataService,
    public parent: AppComponent) { }

  persist() {
    let that = this;
    that.loading = true;
    that.parent.addToast('', 'salvataggio in corso...', ((wid) => {
      setTimeout(function() {
        that.service.persist(that.wmodel).subscribe((res) => {
          console.log(res)

          if (res.success && res.testata) {
            that.wmodel = res.testata;
          }

          that.parent.clearToast(wid);
          that.loading = false;
          that.parent.operSnackBar(res.success, res.success ? 'salvataggio completato' : res.err)
        })
      }, 2000);
    }))
  }

  onNotifyCollana(o: Testata): void {
    console.log('onNotify', o)
  }

  ngOnInit() {
    let codice = this.route.snapshot.paramMap.get('codice');
    console.log(codice);
    if (codice) {
      this.service.getTestata(codice).subscribe(result => {
        console.log(result);
        this.wmodel = new Testata(result.testata);
        console.log(this.wmodel);
      })
    } else {
      this.wmodel = new Testata();
    }
  }

  getTitle(): string {
    return "testata";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/testata/testata-form/testata-form.component.ts